(() => {
  if (window.LuckyScoopHomeMotion) return;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const selectors = [
    '.native-home__products > h2',
    '.native-home__card',
    '.native-home__steps-heading',
    '.native-home__step',
    '.native-home__benefits > h2',
    '.native-home__benefit',
    '.native-home__faq-heading',
    '.native-home__faq-item',
    '.packing-videos__heading',
    '.packing-videos__card',
    '.packing-videos__navigation',
    '.home-newsletter__inner',
  ].join(',');

  const reveal = (element) => {
    element.classList.remove('home-motion-pending');
    element.classList.add('home-motion-revealed');
  };

  const observer = 'IntersectionObserver' in window && !reduceMotion.matches
    ? new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          reveal(entry.target);
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -7% 0px', threshold: 0.08 })
    : null;

  const register = (element, index = 0) => {
    if (!(element instanceof Element) || element.dataset.homeMotionReady === 'true') return;

    element.dataset.homeMotionReady = 'true';
    element.style.setProperty('--home-motion-delay', `${Math.min(index * 45, 225)}ms`);

    if (!observer || element.getBoundingClientRect().top < window.innerHeight * 0.94) {
      reveal(element);
      return;
    }

    element.classList.add('home-motion-pending');
    observer.observe(element);
  };

  const initialize = (root = document) => {
    if (root.matches?.(selectors)) register(root);

    const elements = Array.from(root.querySelectorAll?.(selectors) || []);
    const groupCounts = new Map();
    elements.forEach((element) => {
      const group = element.parentElement;
      const index = groupCounts.get(group) || 0;
      groupCounts.set(group, index + 1);
      register(element, index);
    });
  };

  window.LuckyScoopHomeMotion = { register, initialize };
  initialize();

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
